export interface InitialState {
  filters: string
}

export const initialState: InitialState = {
  filters: `?limit=10&page=1&hasGeolocation=false`
}
